import { Map, Marker, Icon, TileLayer } from "leaflet";

import icon from "./marker.svg";

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

interface MarkerDefinition {
  title: string;
  lat: number;
  lng: number;
}

export default class MapComponent {
  protected map: typeof Map;
  protected markers: typeof Marker[] = [];

  constructor(protected mapContainer:HTMLElement) {
    const markerDefinitions = JSON.parse(mapContainer.dataset.markers) as MarkerDefinition[];
    const center = JSON.parse(mapContainer.dataset.center ?? 'null') ?? [46.800663464,8.222665776];
    const zoom = parseInt(mapContainer.dataset.zoom ?? "6");
    const token = mapContainer.dataset.token ?? "";

    this.map = new Map(mapContainer, {
      center: center,
      zoom: zoom,
      zoomControl: false,
      dragging: !isTouchDevice(),
    });

    this.map.addLayer(new TileLayer("https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}@2x?access_token=" + token, {
      id: 'mapbox/light-v9',
      attribution: `© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <strong><a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a></strong>`,
      tileSize: 512,
      zoomOffset: -1,
    }));

    this.markers = markerDefinitions.map((markerDefinition) => {
      const marker = new Marker(markerDefinition, {
        ...markerDefinition,
        icon: new Icon({
          iconUrl: `data:image/svg+xml,${encodeURIComponent(icon)}`,
          iconSize: [32, 32],
          iconAnchor: [12, 32],
        })
      }).addTo(this.map);
      return marker;
    });
  }
}
